jQuery(document).ready(function($) {
	
	/* Products Slider - BEGIN */
		var productsSlider = $(".products-slider .listing");

		productsSlider.addClass("owl-carousel").owlCarousel({
			items: 3,
			margin: 10,
			dots: false,
			loop: true,
			autoplay: 4500,
			center: true,
			autoplayHoverPause: true,
			responsive: {
				992 : {
					items : 5,
				},
			}
		});

		$(".products-slider").on('click', '#products-slider-prev', function(event) {
			console.log(event);
			productsSlider.trigger('prev.owl.carousel');
		});
		
		$(".products-slider").on('click', '#products-slider-next', function(event) {
			console.log(event);
			productsSlider.trigger('next.owl.carousel');
		});
	/* Products Slider - END */
	
});